(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["compare-sizes-drawer"] && !Shopify.designMode) return;
  try {
    class CompareSizesDrawer {
    constructor() {
      this.init();
    }

    init() {
      document.querySelectorAll('[data-compare-drawer]').forEach(dialog => {
        this.initDialog(dialog);
        this.transformTableToGrid(dialog);
      });
    }

    initDialog(dialog) {
      const closeBtn = dialog.querySelector('[data-close-drawer]');
      
      if (closeBtn) {
        closeBtn.addEventListener('click', () => {
          dialog.classList.add('dialog-closing');
          setTimeout(() => {
            dialog.close();
            dialog.classList.remove('dialog-closing');
          }, 300);
        });
      }

      dialog.addEventListener('click', (e) => {
        if (e.target === dialog) {
          dialog.classList.add('dialog-closing');
          setTimeout(() => {
            dialog.close();
            dialog.classList.remove('dialog-closing');
          }, 300);
        }
      });

      dialog.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          e.preventDefault();
          dialog.classList.add('dialog-closing');
          setTimeout(() => {
            dialog.close();
            dialog.classList.remove('dialog-closing');
          }, 300);
        }
      });
    }

    /**
     * Transform the table HTML into a CSS Grid layout for better image control
     */
    transformTableToGrid(dialog) {
      const tableWrap = dialog.querySelector('.compare-sizes-drawer__table-wrap');
      const table = tableWrap?.querySelector('table');
      
      if (!table) return;

      const thead = table.querySelector('thead');
      const tbody = table.querySelector('tbody');
      
      if (!thead || !tbody) return;

      // Get column count from first row
      const headerCells = thead.querySelectorAll('th');
      const columnCount = headerCells.length;
      
      if (columnCount === 0) return;

      // Create grid container
      const grid = document.createElement('div');
      grid.className = 'compare-grid';
      grid.style.setProperty('--compare-columns', columnCount);

      // Create header row with images
      const headerRow = document.createElement('div');
      headerRow.className = 'compare-grid__row compare-grid__row--header';

      for (const th of headerCells) {
        const cell = document.createElement('div');
        cell.className = 'compare-grid__cell';
        
        // Wrap image in container for consistent sizing
        const img = th.querySelector('img');
        if (img) {
          const imgContainer = document.createElement('div');
          imgContainer.className = 'compare-grid__image-container';
          imgContainer.appendChild(img.cloneNode(true));
          cell.appendChild(imgContainer);
        } else {
          cell.innerHTML = th.innerHTML;
        }
        
        headerRow.appendChild(cell);
      }
      grid.appendChild(headerRow);

      // Create body rows
      const bodyRows = tbody.querySelectorAll('tr');
      let rowIndex = 0;

      for (const tr of bodyRows) {
        const row = document.createElement('div');
        row.className = 'compare-grid__row';
        
        // First row has titles and shop buttons
        if (rowIndex === 0) {
          row.classList.add('compare-grid__row--title');
        }

        const cells = tr.querySelectorAll('td');
        for (const td of cells) {
          const cell = document.createElement('div');
          cell.className = 'compare-grid__cell';
          cell.innerHTML = td.innerHTML;
          row.appendChild(cell);
        }

        grid.appendChild(row);
        rowIndex++;
      }

      // Replace table with grid
      table.replaceWith(grid);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new CompareSizesDrawer());
  } else {
    new CompareSizesDrawer();
  }
  } catch(e) { console.error(e); }
})();

})();
